import { LOOKUP_ENTITY_KEY_TO_UI_KEYS, normalizeRuleOperatorRow, readLookupNumber, normalizeLookupOption, normalizeLookupGroup, mapLookupGroupsToOptions, lookupValuesFromOptions, normalizeReportDataColumn, normalizeReportDataModel, mapReportDataModels, normalizeReportConfigurationClient } from "./mapping/referenceDataMapping";
import { findExistingPlanForClient, buildPlanFromClient, mergeClientLookupsIntoData, reportFolderUiId, reportUiId } from "./mapping/reportPlanMapping";
import * as reportPlanMapping from "./mapping/reportPlanMapping";
import * as lookupResolution from "./logic/lookupResolution";
import * as ruleInterpretation from "./logic/ruleInterpretation";
import * as catalogResolution from "./logic/catalogResolution";
import * as sqlExpressions from "./logic/sqlExpressions";
import * as sqlPreview from "./logic/sqlPreview";
import * as exclusionSqlPreview from "./logic/exclusionSqlPreview";
import * as summaries from "./logic/summaries";
import * as narrative from "./logic/narrative";
import * as workbookLayout from "./logic/workbookLayout";
import * as metrics from "./logic/metrics";
import * as operatorCatalog from "./logic/operatorCatalog";
import * as periodDate from "./logic/periodDate";
import * as dateParts from "./logic/dateParts";
import * as periodBounds from "./logic/periodBounds";
import { PERIOD_START_OPERATOR_OPTIONS, PERIOD_END_OPERATOR_OPTIONS, PERIOD_IF_BLANK_OPTIONS, defaultEndOperator, makePeriodBounds, periodBoundsFor, metricOverridesReportPeriod, makeMetricPeriodFilter, metricPeriodFilterLogic } from "./logic/periodBounds";
import * as detailRuleSets from "./logic/detailRuleSets";
import * as combinedRuleSetLogic from "./logic/combinedRuleSets";
import type { CombinedIssue, RuleSetCategories } from "./logic/combinedRuleSets";
import { COMBINED_MIN_RULE_SETS, COMBINED_ROW_LABEL_MAX_LENGTH, activeCombinedRows, combinedRowLabel, combinedRows, combinedRuleSetIds, generatedCombinedRowLabel, usesCombinedRuleSets } from "./logic/combinedRuleSetSelection";
import { moveInList, ruleSetProducesCategory, removeCombinedRuleSet, stripSqlLineComments, withCombinedRowChange, withCombinedRowLabel } from "./logic/combinedRuleSets";
import * as calculatedFieldLogic from "./logic/calculatedFields";
import * as textCalculatedFieldLogic from "./logic/textCalculatedFields";
import * as calculatedColumnLogic from "./logic/calculatedColumns";
import * as detailAggregateLogic from "./logic/detailAggregates";
import { DETAIL_AGGREGATES, allowedDetailAggregates, defaultFormatForAggregate, detailAggregateDef, detailAggregateHeader, detailAggregateOf, usesDetailAggregates } from "./logic/detailAggregates";
import type { DetailAggregateIssue, DetailOutputValueType } from "./logic/detailAggregates";
import type { CalculatedColumnUse } from "./logic/calculatedColumns";
import { DATE_PARTS, datePartDef, datePartFitsColumn, datePartsForColumn, isTimeOfDayColumn } from "./logic/dateParts";
import type { DatePartDef, DatePartGroup } from "./logic/dateParts";
import { MAX_CALC_TEXT_LENGTH, MAX_TEXT_PARTS, MAX_TEXT_SEPARATOR_LENGTH, MAX_TEXT_STEPS, TEXT_DATE_STYLES, TEXT_STEPS, textStepDef } from "./logic/textCalculatedFields";
import type { DetailCalculatedColumn } from "./logic/calculatedFields";
import { DETAIL_CONSTANT_TYPES, DETAIL_CONST_ALIAS_PREFIX, MAX_DETAIL_CONSTANT_COLUMNS, DETAIL_CONSTANT_NAME_MAX_LENGTH, detailConstAlias, isDetailConstAlias, detailConstantColumns, detailConstantIssue, detailConstantIssues, detailConstantSql, detailConstantText } from "./logic/detailConstantColumns";
import { CALC_OPERATORS, MEASURE_AGGREGATES, MAX_CALC_TERMS, MAX_CALC_ROUND_DIGITS, CALC_FIELD_NAME_MAX_LENGTH, DETAIL_CALC_ALIAS_PREFIX, calculatedFields, calculatedFieldsForModel, findCalculatedField, detailCalcAlias, isDetailCalcAlias, detailCalculatedFieldIds, measureLabel, usesMeasureField, parseCalcTerms, isValidCalcNumber } from "./logic/calculatedFields";
import type { DetailRuleSetOutput } from "./logic/detailRuleSets";
import { DETAIL_RULE_SET_ALIAS_MAX_LENGTH, DETAIL_RULE_SET_ALIAS_PREFIX, detailRuleSetAlias, detailRuleSetAliasText, detailRuleSetDisplayName, isDetailRuleSetAlias, selectedDetailRuleSetIds, usesDetailRuleSetList, withDetailRuleSetAlias, withDetailRuleSetIds } from "./logic/detailRuleSetSelection";
import { PERIOD_DATE_LABEL, isPeriodDateExtra, hasPeriodDate, makePeriodDateCase, periodDateGranularities, setPeriodDateGranularity, removePeriodDate, orphanPeriodDateExtras } from "./logic/periodDate";
import type { PeriodDateIssue } from "./logic/periodDate";
import type { MetricFilterMode, RuleNodeIssue } from "./logic/ruleInterpretation";
import {
    PLACEHOLDER_COLUMNS,
    TRIP_DATA_COLUMN_ALIASES,
    dataColumnSelectionKey,
    findTimestampColumn,
    TRIP_DATA_FIELDS,
    extraBreakdownAlias,
    normalizeColumnIdentity,
    columnIdentityValues,
    columnMatchesKey,
    columnsMatch,
    findColumnByIdentity,
    findSelectedDetailColumn,
    calcColumnKey,
    isCalculatedColumn,
    isCalculatedColumnKey,
} from "./logic/catalogResolution";
import {
    RULE_ACTIONS,
    SLA_METRIC_DEFS,
    makeEmptyConfigurationState,
    EMPTY_REPORT_FOLDER,
    EMPTY_PLAN,
    defaultTripDataField,
    defaultTripDataFilterGroup,
    defaultTripDataFilters,
    defaultCallCenterSla,
    activeTripFilterCount,
    reportGlobalFilters,
    findPlan,
    findFolder,
    findReport,
    clone,
    makeReportGlobalFilters,
} from "./logic/metrics";
import {
    metricFilterNodes,
    metricFilterLogic,
    setMetricFilterLogic,
    metricFilterEnabled,
    ruleResultValue,
} from "./logic/ruleInterpretation";
import {
    countAllExpr,
    countMatchingExpr,
    sqlList,
    sqlLiteral,
    nullSafeNotInRaw,
    idSqlList,
    sqlLikeLiteral,
    sqlAlias,
    safeSqlAlias,
    indentSql,
    periodSqlClause,
    qualifySqlColumn,
    sqlCommentText,
    COLUMN_COMPARISON_OPERATORS,
    MINUTES_BETWEEN_OPERATORS,
} from "./logic/sqlExpressions";
import { planPreviewText } from "./logic/summaries";
import { metricBreakdownExpr, cteNameForModel, reportModelKeysForSql } from "./logic/sqlPreview";
import {
    sanitizeExcelSheetName,
    defaultExcelSheetName,
    normalizeExcelSheetName,
    excelSheetKey,
    validateExcelSheetName,
    metricSheetName,
    excelSheetsInUse,
    metricPositionWithinSheet,
    storedExcelSheetName,
    reorderExcelSheets,
    moveExcelDetailColumn,
    excelLayoutValidationMessages,
    excelLayoutColumnHeaders,
    buildExcelLayoutPreview,
} from "./logic/workbookLayout";
import type { ReportLogicContext } from "./logic/context";
import { dataModelColumnLookupKey, scopedDataModelColumnLookupKey, labelLookupKey, dedupeLookupOptions } from "./logic/lookupResolution";
import { RULE_OPERATORS, columnDataTypeCategory, ruleOpDef } from "./logic/operatorCatalog";
import type { RuleOperatorCatalogEntry } from "./logic/operatorCatalog";
import type {
    CalcOperand,
    CalcTextPart,
    CalcTextStep,
    CalcTextStepKind,
    CalculatedFieldResultType,
    CalcTerm,
    CalculatedField,
    CategorizationRule,
    ColumnDataTypeCategory,
    CountMode,
    DataColumn,
    DataModel,
    ExtraBreakdown,
    FilterGroupKey,
    MetricSection,
    ModelKey,
    OtpRule,
    PlanConfig,
    ReportConfig,
    ReportConfigurationClientLookup,
    ReportConfigurationLookupGroup,
    ReportConfigurationLookupOption,
    ReportConfigurationReportDto,
    ReportConfigurationReportFolderDto,
    ReportConfigurationReportPlanDto,
    ReportConfigurationState,
    ReportFolder,
    ReportSubTab,
    RuleCondition,
    RuleConditionGroup,
    RuleNode,
    RuleOperatorKey,
    RuleSet,
    TripDataFieldDef,
    TripDataFieldState,
    ExcelDetailColumnOptions,
    SectionExcelLayout,
    BreakdownSource,
    CombinedRow,
    CombinedRowValue,
    DisplayAs,
} from "./types";
import {
    MAX_RULE_GROUP_DEPTH,
    isRuleGroupNode,
    ruleNodeJoin,
    splitRuleAndRuns,
    ruleNodesHaveMixedJoins,
    ruleNodesUniformJoin,
    setRuleNodesUniformJoin,
    nextRuleJoinForGroup,
    ruleGroupChildren,
    ruleLeafConditions,
    ruleHasNestedGroup,
    ruleTreeDepth,
    findRuleNode,
    ruleNodePath,
    ruleNodeDepth,
    mapRuleNodes,
    appendRuleNode,
    ruleNodeIds,
    dedupeRuleNodeIds,
    canNestRuleGroupNodes,
    canNestRuleGroup,
    simulateConditionValue,
    simulateRuleNodes,
    simulateRuleMatches,
} from "./logic/rules";
import {
    REPORTING_PERIOD_OPTION_DEFS,
    formatReportDate,
    normalizeReportingPeriodType,
    reportingPeriodName,
    isCustomReportingPeriod,
    isLastNReportingPeriod,
    lastNLimit,
    lastNDefault,
    validLastN,
    withBuiltInReportingPeriods,
    DATE_GRANULARITY_OPTIONS,
    dateGranularityExpr,
    granularityLabel,
    periodPlainEnglish,
} from "./logic/reportingPeriods";

export type { RuleNodeIssue, MetricFilterMode } from "./logic/ruleInterpretation";
export type { NarrativeBlock, NarrativeClause, NarrativeSection, RuleBook } from "./logic/narrative";
export type { RuleOperatorCatalogEntry } from "./logic/operatorCatalog";
const STATIC_LOOKUP_ENTITY_KEYS = {
    frequency: "FrequencyType",
    reportingPeriod: "ReportingPeriodType",
    metricDisplay: "MetricDisplayType",
    otpMissingHandling: "OtpMissingHandling",
    ruleAction: "RuleActionType",
    ruleOperator: "RuleOperator",
    tripActivity: "TripActivityMode",
};
// Compatibility-only state for legacy facade exports below. New logic, mapping, state,
// and components should pass ReportLogicContext/catalog data explicitly instead.
let ACTIVE_DATA_MODELS: Record<ModelKey, DataModel> = {};
const setActiveDataModels = (models: Record<ModelKey, DataModel>) => { ACTIVE_DATA_MODELS = models; };
const activeDataModels = () => ACTIVE_DATA_MODELS;
const activeModelKeys = () => Object.keys(ACTIVE_DATA_MODELS) as ModelKey[];
let ACTIVE_LOOKUP_GROUPS: ReportConfigurationLookupGroup[] = [];
let ACTIVE_LOOKUP_OPTIONS_BY_KEY: Record<string, ReportConfigurationLookupOption[]> = {};
const setActiveLookupGroups = (groups: ReportConfigurationLookupGroup[]) => { ACTIVE_LOOKUP_GROUPS = groups; };
const setActiveLookupOptionsByKey = (optionsByKey: Record<string, ReportConfigurationLookupOption[]>) => { ACTIVE_LOOKUP_OPTIONS_BY_KEY = optionsByKey; };

let ACTIVE_RULE_OPERATORS: RuleOperatorCatalogEntry[] = [];

function setActiveRuleOperators(rows: any[]) {
    ACTIVE_RULE_OPERATORS = (Array.isArray(rows) ? rows : [])
        .map(normalizeRuleOperatorRow)
        .filter((row): row is RuleOperatorCatalogEntry => !!row)
        // Only codes the builder knows how to render are kept. A code added to the table
        // that this build has no valueMode or SQL for would otherwise appear in the picker
        // and then silently generate nothing.
        .filter((row) => RULE_OPERATORS.some((operator) => operator.key === row.operatorCode));
}

const activeRuleOperators = () => ACTIVE_RULE_OPERATORS;

function operatorCodesForDataType(category: ColumnDataTypeCategory): RuleOperatorKey[] {
    return operatorCatalog.operatorCodesForDataType(category, activeRuleOperators());
}

function ruleOperatorLabel(operator: RuleOperatorKey) {
    return operatorCatalog.ruleOperatorLabel(operator, activeRuleOperators());
}

function operatorsForColumn(column?: DataColumn | null) {
    return operatorCatalog.operatorsForColumn(column, activeRuleOperators());
}

function isOperatorAllowedForColumn(column: DataColumn | null | undefined, operator: RuleOperatorKey) {
    return operatorCatalog.isOperatorAllowedForColumn(column, operator, activeRuleOperators());
}

function operatorForColumnChange(column: DataColumn | null | undefined, current: RuleOperatorKey): RuleOperatorKey {
    return operatorCatalog.operatorForColumnChange(column, current, activeRuleOperators());
}
const today = new Date().toISOString().slice(0, 10);

let idSeq = 1000;
const nextId = (prefix: string) => `${prefix}_${Date.now().toString(36)}_${idSeq++}`;

function makeReport(id: string, label: string, models: ModelKey[], _seedMetrics = false): ReportConfig {
    return metrics.makeReport(logicContext, id, label, models, _seedMetrics);
}

function reportFromDto(dto: ReportConfigurationReportDto, existing?: ReportConfig): ReportConfig {
    return reportPlanMapping.reportFromDto(makeReport, dto, existing);
}

function reportFolderFromDto(dto: ReportConfigurationReportFolderDto, existingFolders: ReportFolder[]): ReportFolder {
    return reportPlanMapping.reportFolderFromDto(makeReport, dto, existingFolders);
}

function applyReportPlanToPlan(plan: PlanConfig, reportPlan: ReportConfigurationReportPlanDto): PlanConfig {
    return reportPlanMapping.applyReportPlanToPlan(makeReport, plan, reportPlan);
}

function resolveLookupOptionsForColumn(modelKey: ModelKey | "", columnKey: string): ReportConfigurationLookupOption[] {
    return lookupResolution.resolveLookupOptionsForColumn(logicContext, modelKey, columnKey);
}

function resolveOptionIds(modelKey: ModelKey | "", columnKey: string, values: string[]): string[] | null {
    return lookupResolution.resolveOptionIds(logicContext, modelKey, columnKey, values);
}

function makeRuleCondition(): RuleCondition {
    return metrics.makeRuleCondition(logicContext);
}

function makeRuleConditionGroup(logic: "and" | "or" = "or", children?: RuleNode[]): RuleConditionGroup {
    return metrics.makeRuleConditionGroup(logicContext, logic, children);
}

function metricFilterColumns(section: MetricSection) {
    return ruleInterpretation.metricFilterColumns(logicContext, section);
}

function setMetricFilterNodes(section: MetricSection, mode: MetricFilterMode, nodes: RuleNode[]): MetricSection {
    return ruleInterpretation.setMetricFilterNodes(logicContext, section, mode, nodes);
}

function metricFilterOutline(report: ReportConfig, section: MetricSection, mode: MetricFilterMode) {
    return ruleInterpretation.metricFilterOutline(logicContext, report, section, mode);
}

function metricFilterIssues(report: ReportConfig, section: MetricSection, mode: MetricFilterMode): RuleNodeIssue[] {
    return ruleInterpretation.metricFilterIssues(logicContext, report, section, mode);
}

function metricFilterIssuesForSection(report: ReportConfig, section: MetricSection): RuleNodeIssue[] {
    return ruleInterpretation.metricFilterIssuesForSection(logicContext, report, section);
}

function makeCategorizationRule(): CategorizationRule {
    return metrics.makeCategorizationRule(logicContext);
}

function makeRuleSet(name = "Categorization"): RuleSet {
    return metrics.makeRuleSet(logicContext, name);
}

function makeOtpRule(): OtpRule {
    return metrics.makeOtpRule(logicContext);
}

function makeMetric(model: ModelKey | "" = "", column = "", name?: string): MetricSection {
    return metrics.makeMetric(logicContext, model, column, name);
}

function attachModel(report: ReportConfig, modelKey: ModelKey, dataModelId?: number) {
    return catalogResolution.attachModel(logicContext, report, modelKey, dataModelId);
}

function columnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.columnsForModel(logicContext, modelKey);
}

function timestampColumnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.timestampColumnsForModel(logicContext, modelKey);
}

function breakdownColumnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.breakdownColumnsForModel(logicContext, modelKey);
}

function extraBreakdownColumnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.extraBreakdownColumnsForModel(logicContext, modelKey);
}

function isTimestampColumnForModel(modelKey: ModelKey | "", key: string) {
    return catalogResolution.isTimestampColumnForModel(logicContext, modelKey, key);
}

function breakdownColumnForModel(modelKey: ModelKey | "", key: string) {
    return catalogResolution.breakdownColumnForModel(logicContext, modelKey, key);
}

function tripDataColumnForKey(columnKey: string, columns = columnsForModel("transportation")) {
    return catalogResolution.tripDataColumnForKey(logicContext, columnKey, columns);
}

function allSelectableColumnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.allSelectableColumnsForModel(logicContext, modelKey);
}

function resolveCountDistinctColumn(modelKey: ModelKey | "", countMode: CountMode | undefined, countDistinctColumn: string | undefined) {
    return catalogResolution.resolveCountDistinctColumn(logicContext, modelKey, countMode, countDistinctColumn);
}

function detailColumnsForModel(modelKey: ModelKey | "") {
    return catalogResolution.detailColumnsForModel(logicContext, modelKey);
}

function allColumnsAcrossModels(report: ReportConfig) {
    return catalogResolution.allColumnsAcrossModels(logicContext, report);
}

function reportCategoryColumns(report: ReportConfig) {
    return catalogResolution.reportCategoryColumns(logicContext, report);
}

/** Every column a Categorization condition may be built on, across the report's models. */
function reportAllColumns(report: ReportConfig) {
    return catalogResolution.reportAllColumns(logicContext, report);
}

/** Timestamp columns a "minutes between" condition may pick from, across the report's models. */
function reportTimeComparableColumns(report: ReportConfig) {
    return catalogResolution.reportTimeComparableColumns(logicContext, report);
}

/** Columns a condition on `columnKey` may be compared against: same model, same data type. */
function comparableColumnsForColumn(report: ReportConfig, columnKey: string) {
    return catalogResolution.comparableColumnsForColumn(logicContext, report, columnKey);
}

/** The "To" pool for a time difference whose "From" column is already chosen. */
function differenceColumnsForColumn(report: ReportConfig, columnKey: string) {
    return catalogResolution.differenceColumnsForColumn(logicContext, report, columnKey);
}

function columnLabel(columnKey: string) {
    return catalogResolution.columnLabel(logicContext, columnKey);
}

function reportColumnDisplayLabel(report: ReportConfig, columnKey: string) {
    return catalogResolution.reportColumnDisplayLabel(logicContext, report, columnKey);
}

function inClause(modelKey: ModelKey | "", column: DataColumn, values: string[], useIds: boolean) {
    return sqlExpressions.inClause(logicContext, modelKey, column, values, useIds);
}

function notInClause(modelKey: ModelKey | "", column: DataColumn, values: string[], useIds: boolean) {
    return sqlExpressions.notInClause(logicContext, modelKey, column, values, useIds);
}

function targetFields(report?: ReportConfig) {
    return catalogResolution.targetFields(logicContext, report);
}

function modelColumnByKey(modelKey: ModelKey, columnKey: string) {
    return catalogResolution.modelColumnByKey(logicContext, modelKey, columnKey);
}

function reportExclusionClausesForModel(report: ReportConfig, modelKey: ModelKey) {
    return sqlPreview.reportExclusionClausesForModel(logicContext, report, modelKey);
}

function tripDataFieldMatchExpr(column: DataColumn, field: TripDataFieldDef, state: TripDataFieldState, modelKey: ModelKey, useIds = false) {
    return sqlPreview.tripDataFieldMatchExpr(logicContext, column, field, state, modelKey, useIds);
}

function tripDataGroupExpr(report: ReportConfig, modelKey: ModelKey, groupKey: FilterGroupKey, useIds = false) {
    return sqlPreview.tripDataGroupExpr(logicContext, report, modelKey, groupKey, useIds);
}

function tripDataClausesForModel(report: ReportConfig, modelKey: ModelKey, useIds = false) {
    return sqlPreview.tripDataClausesForModel(logicContext, report, modelKey, useIds);
}

function periodClauseForModel(report: ReportConfig, modelKey: ModelKey) {
    return sqlPreview.periodClauseForModel(logicContext, report, modelKey);
}

function extraBreakdownExprs(section: MetricSection, report?: ReportConfig) {
    return sqlPreview.extraBreakdownExprs(logicContext, section, report);
}

// --- Period Date (logic/periodDate.ts) ----------------------------------------------
function periodDateColumns(section: MetricSection) {
    return periodDate.periodDateColumns(logicContext, section);
}

function periodDateColumn(section: MetricSection, key: string | undefined) {
    return periodDate.periodDateColumn(logicContext, section, key);
}

function enablePeriodDate(report: ReportConfig, section: MetricSection, yearId: string, monthId: string) {
    return periodDate.enablePeriodDate(logicContext, report, section, yearId, monthId);
}

function periodDateExpr(report: ReportConfig, section: MetricSection, useIds = false) {
    return periodDate.periodDateExpr(logicContext, report, section, useIds);
}

function periodDateIssues(report: ReportConfig, section: MetricSection) {
    return periodDate.periodDateIssues(logicContext, report, section);
}

function periodDateNarrative(report: ReportConfig, section: MetricSection) {
    return periodDate.periodDateNarrative(logicContext, report, section);
}

// --- Reporting period bounds / per-metric override (logic/periodBounds.ts) ---------
function periodBoundsIssues(report: ReportConfig, modelKey: ModelKey) {
    return periodBounds.periodBoundsIssues(logicContext, report, modelKey);
}

function periodBoundsPhrase(report: ReportConfig, modelKey: ModelKey) {
    return periodBounds.periodBoundsPhrase(logicContext, report, modelKey);
}

function metricPeriodFilterIssues(report: ReportConfig, section: MetricSection) {
    return periodBounds.metricPeriodFilterIssues(logicContext, report, section);
}

function metricPeriodFilterOutline(report: ReportConfig, section: MetricSection) {
    return periodBounds.metricPeriodFilterOutline(logicContext, report, section);
}

function metricPeriodFilterExpr(report: ReportConfig, section: MetricSection, useIds = false) {
    return periodBounds.metricPeriodFilterExpr(logicContext, report, section, useIds);
}

function extraBreakdownLabel(section: MetricSection, extra: ExtraBreakdown) {
    return periodDate.extraBreakdownLabel(logicContext, section, extra);
}

function otpRuleColSql(section: MetricSection, key: string) {
    return sqlExpressions.otpRuleColSql(logicContext, section, key);
}

function buildLateConditionSql(section: MetricSection, useIds = false) {
    return sqlExpressions.buildLateConditionSql(logicContext, section, useIds);
}

function findReportColumn(report: ReportConfig, columnKey: string) {
    return catalogResolution.findReportColumn(logicContext, report, columnKey);
}

function targetFieldDef(fieldKey: string, report?: ReportConfig) {
    return catalogResolution.targetFieldDef(logicContext, fieldKey, report);
}

function ruleConditionSql(report: ReportConfig, condition: RuleCondition, useIds = false) {
    return ruleInterpretation.ruleConditionSql(logicContext, report, condition, useIds);
}

function ruleNodesExpression(report: ReportConfig, nodes: RuleNode[] | null | undefined, logic: "and" | "or", useIds = false): string | null {
    return ruleInterpretation.ruleNodesExpression(logicContext, report, nodes, logic, useIds);
}

function ruleConditionExpression(report: ReportConfig, rule: CategorizationRule, useIds = false) {
    return ruleInterpretation.ruleConditionExpression(logicContext, report, rule, useIds);
}

function ruleConditionOutline(report: ReportConfig, condition: RuleCondition) {
    return ruleInterpretation.ruleConditionOutline(logicContext, report, condition);
}

function ruleNodesOutline(report: ReportConfig, nodes: RuleNode[] | null | undefined, logic: "and" | "or"): string {
    return ruleInterpretation.ruleNodesOutline(logicContext, report, nodes, logic);
}

function ruleLogicOutline(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleLogicOutline(logicContext, report, rule);
}

function ruleLogicComment(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleLogicComment(logicContext, report, rule);
}

function buildCatRulesColumns(report: ReportConfig, ruleSet?: RuleSet, useIds = false, categoryFallbackColumn: DataColumn | null = null) {
    return ruleInterpretation.buildCatRulesColumns(logicContext, report, ruleSet, useIds, categoryFallbackColumn);
}

function buildRuleFilterClauses(report: ReportConfig, ruleSet?: RuleSet, useIds = false) {
    return ruleInterpretation.buildRuleFilterClauses(logicContext, report, ruleSet, useIds);
}

function isCategorizationRuleReady(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.isCategorizationRuleReady(logicContext, report, rule);
}

/** What a Set rule writes, for display: its typed value, or "the value of <column>". */
function ruleResultLabel(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleResultLabel(logicContext, report, rule);
}

/** A column-sourced Set rule's source column, resolved on its rule set's model and eligible, or null. */
function ruleValueColumn(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleValueColumn(logicContext, report, rule);
}

/** True when a Set rule has something to write: a typed value, or a usable source column. */
function ruleHasResult(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleHasResult(logicContext, report, rule);
}

/** Why a column-sourced Set rule cannot produce its value, or null. */
function ruleValueSourceIssue(report: ReportConfig, rule: CategorizationRule) {
    return ruleInterpretation.ruleValueSourceIssue(logicContext, report, rule);
}

/**
 * The columns a Set rule may take its value from: eligible columns on its rule set's model,
 * or across the report's models while nothing in the rule set has pinned a model yet.
 */
function ruleValueSourceColumns(report: ReportConfig, rule: CategorizationRule) {
    const ruleSet = report.bucketRuleSets.find((set) => set.rules.some((item) => item.id === rule.id));
    const modelKey = ruleSet ? ruleInterpretation.ruleSetModelKey(logicContext, report, ruleSet, false) : "";
    return catalogResolution.ruleValueSourceColumns(logicContext, report, modelKey);
}

function categorizationRuleIssues(report: ReportConfig, rule: CategorizationRule): RuleNodeIssue[] {
    return ruleInterpretation.categorizationRuleIssues(logicContext, report, rule);
}

function ruleSetIssues(report: ReportConfig, ruleSet?: RuleSet): Record<string, RuleNodeIssue[]> {
    return ruleInterpretation.ruleSetIssues(logicContext, report, ruleSet);
}

function isRuleSetReady(report: ReportConfig, ruleSet?: RuleSet) {
    return ruleInterpretation.isRuleSetReady(logicContext, report, ruleSet);
}

function buildBaseWhereClauses(plan: PlanConfig, report: ReportConfig, modelKey: ModelKey, useIds = false) {
    return sqlPreview.buildBaseWhereClauses(logicContext, plan, report, modelKey, useIds);
}

function buildMetricFilterClauses(report: ReportConfig, section: MetricSection, column?: DataColumn, useIds = false) {
    return ruleInterpretation.buildMetricFilterClauses(logicContext, report, section, column, useIds);
}

function simulateRuleSet(report: ReportConfig, ruleSet: RuleSet, inputs: Record<string, string>) {
    return ruleInterpretation.simulateRuleSet(logicContext, report, ruleSet, inputs);
}

function buildWhereClauses(plan: PlanConfig, report: ReportConfig, section: MetricSection, column?: DataColumn, useIds = false) {
    return sqlPreview.buildWhereClauses(logicContext, plan, report, section, column, useIds);
}

function isMetricReady(report: ReportConfig, section: MetricSection) {
    return ruleInterpretation.isMetricReady(logicContext, report, section);
}

function buildSqlForSection(plan: PlanConfig, report: ReportConfig, section: MetricSection, useIds = false) {
    return sqlPreview.buildSqlForSection(logicContext, plan, report, section, useIds);
}

function modelKeyForRuleSet(report: ReportConfig, ruleSet: RuleSet) {
    return sqlPreview.modelKeyForRuleSet(logicContext, report, ruleSet);
}

function buildCategorizationRuleSetSql(plan: PlanConfig, report: ReportConfig, ruleSet: RuleSet) {
    return sqlPreview.buildCategorizationRuleSetSql(logicContext, plan, report, ruleSet);
}

function buildCategorizationSqlPreview(plan: PlanConfig, report: ReportConfig) {
    return sqlPreview.buildCategorizationSqlPreview(logicContext, plan, report);
}

function buildCallCenterSql(plan: PlanConfig, report: ReportConfig, useIds = false) {
    return sqlPreview.buildCallCenterSql(logicContext, plan, report, useIds);
}

function ruleSetComputedColumnsForModel(report: ReportConfig, modelKey: ModelKey) {
    return sqlPreview.ruleSetComputedColumnsForModel(logicContext, report, modelKey);
}

function combinedCategorizationColumnsForModel(report: ReportConfig, modelKey: ModelKey) {
    return sqlPreview.combinedCategorizationColumnsForModel(logicContext, report, modelKey);
}

function ruleMetricColumn(report: ReportConfig, section: MetricSection) {
    return sqlPreview.ruleMetricColumn(logicContext, report, section);
}

function categorizationOverrideForMetric(report: ReportConfig, section: MetricSection, metricColumn?: DataColumn) {
    return sqlPreview.categorizationOverrideForMetric(logicContext, report, section, metricColumn);
}

function metricBreakdownSql(report: ReportConfig, section: MetricSection, column: DataColumn) {
    return sqlPreview.metricBreakdownSql(logicContext, report, section, column);
}

function categorizationFilterClausesForMetric(report: ReportConfig, section: MetricSection, column: DataColumn) {
    return sqlPreview.categorizationFilterClausesForMetric(logicContext, report, section, column);
}

function matchingComputedColumn(report: ReportConfig, computedColumns: { fieldKey: string; alias: string; expr: string }[], column: DataColumn) {
    return sqlPreview.matchingComputedColumn(logicContext, report, computedColumns, column);
}

function buildMetricSource(plan: PlanConfig, report: ReportConfig, section: MetricSection, column: DataColumn, where: string[]) {
    return sqlPreview.buildMetricSource(logicContext, plan, report, section, column, where);
}

function sourceSqlForColumn(report: ReportConfig, computedColumns: { fieldKey: string; alias: string; expr: string }[], column: DataColumn) {
    return sqlPreview.sourceSqlForColumn(logicContext, report, computedColumns, column);
}

function detailSelectSqlForColumn(report: ReportConfig, computedColumns: { fieldKey: string; alias: string; expr: string }[], column: DataColumn) {
    return sqlPreview.detailSelectSqlForColumn(logicContext, report, computedColumns, column);
}

function buildReportCtes(plan: PlanConfig, report: ReportConfig, modelKeys: ModelKey[]) {
    return sqlPreview.buildReportCtes(logicContext, plan, report, modelKeys);
}

function metricResultSelect(report: ReportConfig, section: MetricSection) {
    return sqlPreview.metricResultSelect(logicContext, report, section);
}

function buildReportSqlPreview(plan: PlanConfig, report: ReportConfig) {
    return sqlPreview.buildReportSqlPreview(logicContext, plan, report);
}

function buildSqlPreview(plan: PlanConfig, report?: ReportConfig, _activeSubTab?: ReportSubTab, useIds = false) {
    return sqlPreview.buildSqlPreview(logicContext, plan, report, _activeSubTab, useIds);
}

function buildExclusionSqlPreview(plan: PlanConfig, report?: ReportConfig, useIds = false) {
    return exclusionSqlPreview.buildExclusionSqlPreview(logicContext, plan, report, useIds);
}

function buildPlainEnglish(plan: PlanConfig, report?: ReportConfig, lookupValues: Record<string, string[]> = {}, clientOptions?: ReportConfigurationLookupOption[]) {
    return summaries.buildPlainEnglish(logicContext, plan, report, lookupValues, clientOptions);
}

/** The configuration as a readable document - see logic/narrative.ts. */
function buildRuleBook(plan: PlanConfig, report?: ReportConfig, clientOptions?: ReportConfigurationLookupOption[]) {
    return narrative.buildRuleBook(logicContext, plan, report, clientOptions);
}

/** The same document as flat text, for copying and for the saved plainEnglishText. */
function buildRuleBookText(plan: PlanConfig, report?: ReportConfig, clientOptions?: ReportConfigurationLookupOption[]) {
    return narrative.ruleBookPlainText(narrative.buildRuleBook(logicContext, plan, report, clientOptions));
}

function setMetricExcelSheet(report: ReportConfig, sectionId: string, sheetName: string): ReportConfig {
    return workbookLayout.setMetricExcelSheet(logicContext, report, sectionId, sheetName);
}

function moveExcelSheet(report: ReportConfig, fromSheetName: string, toSheetName: string): ReportConfig {
    return workbookLayout.moveExcelSheet(logicContext, report, fromSheetName, toSheetName);
}

function renameExcelSheet(report: ReportConfig, fromSheetName: string, toSheetName: string): ReportConfig {
    return workbookLayout.renameExcelSheet(logicContext, report, fromSheetName, toSheetName);
}

function reorderExcelMetrics(report: ReportConfig, sheetName: string, draggedSectionId: string, targetSectionId: string, placement: "before" | "after" = "before"): ReportConfig {
    return workbookLayout.reorderExcelMetrics(logicContext, report, sheetName, draggedSectionId, targetSectionId, placement);
}

function excelSectionAliases(section: MetricSection, report?: ReportConfig): { sourceAlias: string; label: string; extraBreakdownId?: string }[] {
    return workbookLayout.excelSectionAliases(logicContext, section, report);
}

function makeDefaultExcelLayout(section: MetricSection, report?: ReportConfig): SectionExcelLayout {
    return workbookLayout.makeDefaultExcelLayout(logicContext, section, report);
}

function makeDefaultExcelDetailColumnOptions(modelKey: MetricSection["model"], selectionKey: string, label: string): ExcelDetailColumnOptions {
    return workbookLayout.makeDefaultExcelDetailColumnOptions(logicContext, modelKey, selectionKey, label);
}

function reconcileExcelLayoutColumns(section: MetricSection, layout: SectionExcelLayout, report?: ReportConfig): SectionExcelLayout {
    return workbookLayout.reconcileExcelLayoutColumns(logicContext, section, layout, report);
}

function detailRuleSetOutputs(report: ReportConfig | null | undefined, section: MetricSection, useIds = false, categoryFallbackColumn: DataColumn | null = null): DetailRuleSetOutput[] {
    return detailRuleSets.detailRuleSetOutputs(logicContext, report, section, useIds, categoryFallbackColumn);
}

// --- Combined categorizations (logic/combinedRuleSets.ts) ------------------------------

function ruleSetCategories(report: ReportConfig, ruleSet: RuleSet): RuleSetCategories {
    return combinedRuleSetLogic.ruleSetCategories(logicContext, report, ruleSet);
}

function combinedRuleSetUnavailableReason(report: ReportConfig, section: MetricSection, ruleSet: RuleSet) {
    return combinedRuleSetLogic.combinedRuleSetUnavailableReason(logicContext, report, section, ruleSet);
}

function combinedRuleSetSummary(report: ReportConfig, ruleSet: RuleSet) {
    return combinedRuleSetLogic.combinedRuleSetSummary(logicContext, report, ruleSet);
}

function combinedRuleSetOtherModelLabel(report: ReportConfig, section: MetricSection, ruleSet: RuleSet) {
    return combinedRuleSetLogic.combinedRuleSetOtherModelLabel(logicContext, report, section, ruleSet);
}

function combinedOtherModelLabels(report: ReportConfig, section: MetricSection) {
    return combinedRuleSetLogic.combinedOtherModelKeys(logicContext, report, section).map((modelKey) => logicContext.dataModels[modelKey]?.label || modelKey);
}

function combinedRuleSetScope(report: ReportConfig, ruleSet: RuleSet) {
    return combinedRuleSetLogic.combinedRuleSetScope(logicContext, report, ruleSet);
}

function combinedShareExplanation(report: ReportConfig, row: CombinedRow) {
    return combinedRuleSetLogic.combinedShareExplanation(logicContext, report, row);
}

function makeCombinedRow(ruleSetId: string, category: string, value: CombinedRowValue): CombinedRow {
    return combinedRuleSetLogic.makeCombinedRow(logicContext, ruleSetId, category, value);
}

function seedCombinedRows(report: ReportConfig, ruleSetId: string): CombinedRow[] {
    return combinedRuleSetLogic.seedCombinedRows(logicContext, report, ruleSetId);
}

function countAndShareRows(ruleSetId: string, category: string): CombinedRow[] {
    return combinedRuleSetLogic.countAndShareRows(logicContext, ruleSetId, category);
}

function duplicateCombinedRow(section: MetricSection, rowId: string): MetricSection {
    return combinedRuleSetLogic.duplicateCombinedRow(logicContext, section, rowId);
}

function addCombinedRuleSet(report: ReportConfig, section: MetricSection, ruleSetId: string) {
    return combinedRuleSetLogic.addCombinedRuleSet(logicContext, report, section, ruleSetId);
}

function switchBreakdownSource(report: ReportConfig, section: MetricSection, next: BreakdownSource) {
    return combinedRuleSetLogic.switchBreakdownSource(logicContext, report, section, next);
}

function switchDisplayAs(report: ReportConfig, section: MetricSection, displayAs: DisplayAs) {
    return combinedRuleSetLogic.switchDisplayAs(logicContext, report, section, displayAs);
}

function combinedRuleSetIssues(report: ReportConfig, section: MetricSection): CombinedIssue[] {
    return combinedRuleSetLogic.combinedRuleSetIssues(logicContext, report, section);
}

function combinedRowCountColumns(report: ReportConfig, section: MetricSection, row: CombinedRow) {
    return combinedRuleSetLogic.combinedRowCountColumns(logicContext, report, section, row);
}

// --- Calculated fields (logic/calculatedFields.ts) ------------------------------------

function makeCalculatedField(model: ModelKey | "", name = "Calculated Field"): CalculatedField {
    return { id: nextId("calc"), name, model, terms: [{ id: nextId("term"), operand: { kind: "column", column: "" } }], roundTo: 2, divideByZero: "blank", blankAs: "blank" };
}

function makeCalcTerm(operator?: CalcTerm["operator"], operand: CalcOperand = { kind: "column", column: "" }): CalcTerm {
    return operator ? { id: nextId("term"), operator, operand } : { id: nextId("term"), operand };
}

/** A new text piece: a column (or typed text) with no steps yet. */
function makeTextPart(sourceKind: CalcTextPart["sourceKind"] = "column"): CalcTextPart {
    return sourceKind === "text" ? { id: nextId("tpart"), sourceKind, value: "", steps: [] } : { id: nextId("tpart"), sourceKind, column: "", steps: [] };
}

function makeTextStep(kind: CalcTextStepKind): CalcTextStep {
    return textCalculatedFieldLogic.defaultTextStep(nextId("tstep"), kind);
}

/** The field switched to another result type with a fresh, empty definition of that type. */
function withCalculatedFieldResultType(field: CalculatedField, resultType: CalculatedFieldResultType): CalculatedField {
    const cleared = { ...field, textParts: undefined, textSeparator: undefined, dateColumn: undefined, datePart: undefined };
    if (resultType === "text") return { ...cleared, resultType: "text", terms: [makeCalcTerm()], textParts: [makeTextPart()], textSeparator: "" };
    // A date part has no formula; `terms` stays an empty list so older readers see no formula.
    if (resultType === "datePart") return { ...cleared, resultType: "datePart", terms: [], roundTo: null, dateColumn: "", datePart: "day_name" };
    return { ...cleared, resultType: "number", terms: [makeCalcTerm()] };
}

function isDatePartCalculatedField(field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.isDatePartCalculatedField(field);
}

function calculatedFieldValueType(field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.calculatedFieldValueType(field);
}

// --- Full Row Detail aggregated sheet columns (logic/detailAggregates.ts) -------------

function detailOutputValueType(report: ReportConfig | null | undefined, section: MetricSection, sourceAlias: string) {
    return detailAggregateLogic.detailOutputValueType(logicContext, report, section, sourceAlias);
}

function detailAggregateIssues(report: ReportConfig | null | undefined, section: MetricSection) {
    return detailAggregateLogic.detailAggregateIssues(logicContext, report, section);
}

/** A column's name in a column picker: calculated fields are marked so they read as such. */
function columnPickerLabel(column: DataColumn) {
    return isCalculatedColumn(column) ? `${column.label} (Calculated)` : column.label;
}

/** Date / time columns a date-part field may take a part from. */
function datePartColumns(modelKey: ModelKey | "") {
    return dateParts.datePartColumns(logicContext, modelKey);
}

function isTextCalculatedField(field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.isTextCalculatedField(field);
}

function numberCalculatedFieldsForModel(report: ReportConfig | null | undefined, modelKey: ModelKey | "") {
    return calculatedFieldLogic.numberCalculatedFieldsForModel(report, modelKey);
}

function calcTextColumns(modelKey: ModelKey | "") {
    return textCalculatedFieldLogic.calcTextColumns(logicContext, modelKey);
}

function calcTextOnlyColumns(modelKey: ModelKey | "") {
    return textCalculatedFieldLogic.calcTextOnlyColumns(logicContext, modelKey);
}

function calcNumberColumns(modelKey: ModelKey | "") {
    return calculatedFieldLogic.calcNumberColumns(logicContext, modelKey);
}

function calcDateColumns(modelKey: ModelKey | "") {
    return calculatedFieldLogic.calcDateColumns(logicContext, modelKey);
}

function calculatedFieldSql(report: ReportConfig, field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.calculatedFieldSql(logicContext, report, field);
}

function calculatedFieldEnglish(field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.calculatedFieldEnglish(logicContext, field);
}

function calculatedFieldIssues(report: ReportConfig, field: CalculatedField) {
    return calculatedFieldLogic.calculatedFieldIssues(logicContext, report, field);
}

function isCalculatedFieldReady(report: ReportConfig, field: CalculatedField | null | undefined) {
    return calculatedFieldLogic.isCalculatedFieldReady(logicContext, report, field);
}

function simulateCalculatedField(field: CalculatedField, inputs: Record<string, string>) {
    return calculatedFieldLogic.simulateCalculatedField(logicContext, field, inputs);
}

function calculatedFieldInputColumns(field: CalculatedField) {
    return calculatedFieldLogic.calculatedFieldInputColumns(logicContext, field);
}

function calcDifferenceUnits(field: CalculatedField, operand: CalcOperand) {
    return calculatedFieldLogic.calcDifferenceUnits(logicContext, field, operand);
}

function detailCalculatedColumns(report: ReportConfig | null | undefined, section: MetricSection): DetailCalculatedColumn[] {
    return calculatedFieldLogic.detailCalculatedColumns(logicContext, report, section);
}

function measureIssue(report: ReportConfig, section: MetricSection) {
    return calculatedFieldLogic.measureIssue(logicContext, report, section);
}

/**
 * Every metric using a calculated field - as a detail column, a measure, a breakdown, an
 * include / exclude list or a filter condition. Shown before the field is deleted or moved.
 */
function metricsUsingCalculatedField(report: ReportConfig, fieldId: string) {
    const columnUses = new Set(calculatedColumnLogic.calculatedColumnUses(report, fieldId).filter((use) => use.kind === "metric").map((use) => use.ownerId));
    return report.sections.filter((section) => section.measure?.fieldId === fieldId || (section.detailCalculatedFieldIds || []).includes(fieldId) || columnUses.has(section.id));
}

/** Every breakdown / filter / rule condition using the field as a column (logic/calculatedColumns.ts). */
function calculatedColumnUses(report: ReportConfig, fieldId: string): CalculatedColumnUse[] {
    return calculatedColumnLogic.calculatedColumnUses(report, fieldId);
}

/** Categorization rule sets with a condition on the field. */
function ruleSetsUsingCalculatedField(report: ReportConfig, fieldId: string) {
    const ids = new Set(calculatedColumnLogic.calculatedColumnUses(report, fieldId).filter((use) => use.kind === "categorization").map((use) => use.ownerId));
    return report.bucketRuleSets.filter((ruleSet) => ids.has(ruleSet.id));
}

/** Why a saved column key naming a calculated field does not resolve on `modelKey`; null otherwise. */
function calculatedColumnReferenceIssue(report: ReportConfig, modelKey: ModelKey | "", columnKey: string) {
    return calculatedColumnLogic.calculatedColumnReferenceIssue(logicContext, report, modelKey, columnKey);
}

/**
 * Removes a calculated field and every reference to it: detail columns, measures, and its
 * uses as a column (breakdowns cleared, extra breakdowns and conditions on it removed).
 */
function withoutCalculatedField(report: ReportConfig, fieldId: string): ReportConfig {
    const withoutColumnUses = calculatedColumnLogic.withoutCalculatedColumnUses(report, fieldId);
    return {
        ...withoutColumnUses,
        calculatedFields: calculatedFields(report).filter((field) => field.id !== fieldId),
        sections: withoutColumnUses.sections.map((section) => {
            const usesMeasure = section.measure?.fieldId === fieldId;
            const usesDetail = (section.detailCalculatedFieldIds || []).includes(fieldId);
            if (!usesMeasure && !usesDetail) return section;
            return {
                ...section,
                ...(usesMeasure ? { measure: null } : {}),
                ...(usesDetail ? { detailCalculatedFieldIds: (section.detailCalculatedFieldIds || []).filter((id) => id !== fieldId) } : {}),
            };
        }),
    };
}

// The report being edited. Its calculated fields are added to the data models every facade
// function reads (logic/calculatedColumns.ts), so pickers, previews, narrative and validation
// all see them as columns. Set by ReportConfiguration.tsx on every render; the SQL builders
// also re-derive the columns from the report they are given, so building another report's SQL
// never sees this report's fields.
let ACTIVE_REPORT: ReportConfig | null = null;
const setActiveReport = (report: ReportConfig | null | undefined) => { ACTIVE_REPORT = report || null; };

const catalogLogicContext: ReportLogicContext = {
    get dataModels() { return ACTIVE_DATA_MODELS; },
    get lookupGroups() { return ACTIVE_LOOKUP_GROUPS; },
    get lookupOptionsByKey() { return ACTIVE_LOOKUP_OPTIONS_BY_KEY; },
    get ruleOperators() { return ACTIVE_RULE_OPERATORS; },
    nextId,
    today,
};

const logicContext: ReportLogicContext = {
    get dataModels() { return calculatedColumnLogic.dataModelsWithCalculatedColumns(catalogLogicContext, ACTIVE_REPORT); },
    get lookupGroups() { return ACTIVE_LOOKUP_GROUPS; },
    get lookupOptionsByKey() { return ACTIVE_LOOKUP_OPTIONS_BY_KEY; },
    get ruleOperators() { return ACTIVE_RULE_OPERATORS; },
    nextId,
    today,
};

export {
    PERIOD_START_OPERATOR_OPTIONS,
    PERIOD_END_OPERATOR_OPTIONS,
    PERIOD_IF_BLANK_OPTIONS,
    defaultEndOperator,
    makePeriodBounds,
    periodBoundsFor,
    periodBoundsIssues,
    periodBoundsPhrase,
    metricOverridesReportPeriod,
    makeMetricPeriodFilter,
    metricPeriodFilterLogic,
    metricPeriodFilterIssues,
    metricPeriodFilterOutline,
    metricPeriodFilterExpr,
    LOOKUP_ENTITY_KEY_TO_UI_KEYS,
    STATIC_LOOKUP_ENTITY_KEYS,
    REPORTING_PERIOD_OPTION_DEFS,
    ACTIVE_DATA_MODELS,
    setActiveDataModels,
    activeDataModels,
    activeModelKeys,
    setActiveLookupGroups,
    setActiveLookupOptionsByKey,
    resolveLookupOptionsForColumn,
    resolveOptionIds,
    PLACEHOLDER_COLUMNS,
    TRIP_DATA_COLUMN_ALIASES,
    dataColumnSelectionKey,
    findTimestampColumn,
    TRIP_DATA_FIELDS,
    RULE_OPERATORS,
    RULE_ACTIONS,
    SLA_METRIC_DEFS,
    today,
    formatReportDate,
    idSeq,
    nextId,
    clone,
    makeEmptyConfigurationState,
    EMPTY_REPORT_FOLDER,
    EMPTY_PLAN,
    readLookupNumber,
    dataModelColumnLookupKey,
    scopedDataModelColumnLookupKey,
    labelLookupKey,
    normalizeLookupOption,
    normalizeLookupGroup,
    dedupeLookupOptions,
    mapLookupGroupsToOptions,
    lookupValuesFromOptions,
    normalizeReportDataColumn,
    normalizeReportDataModel,
    mapReportDataModels,
    normalizeReportingPeriodType,
    reportingPeriodName,
    isCustomReportingPeriod,
    isLastNReportingPeriod,
    lastNLimit,
    lastNDefault,
    validLastN,
    withBuiltInReportingPeriods,
    defaultTripDataField,
    defaultTripDataFilterGroup,
    defaultTripDataFilters,
    defaultCallCenterSla,
    makeRuleCondition,
    makeRuleConditionGroup,
    MAX_RULE_GROUP_DEPTH,
    isRuleGroupNode,
    ruleNodeJoin,
    splitRuleAndRuns,
    ruleNodesHaveMixedJoins,
    ruleNodesUniformJoin,
    setRuleNodesUniformJoin,
    nextRuleJoinForGroup,
    ruleGroupChildren,
    ruleLeafConditions,
    ruleHasNestedGroup,
    ruleTreeDepth,
    findRuleNode,
    ruleNodePath,
    ruleNodeDepth,
    mapRuleNodes,
    appendRuleNode,
    ruleNodeIds,
    dedupeRuleNodeIds,
    canNestRuleGroup,
    canNestRuleGroupNodes,
    setActiveRuleOperators,
    activeRuleOperators,
    ruleOperatorLabel,
    columnDataTypeCategory,
    operatorsForColumn,
    isOperatorAllowedForColumn,
    operatorForColumnChange,
    metricFilterColumns,
    metricFilterNodes,
    metricFilterLogic,
    setMetricFilterNodes,
    setMetricFilterLogic,
    metricFilterEnabled,
    metricFilterOutline,
    metricFilterIssues,
    metricFilterIssuesForSection,
    makeCategorizationRule,
    makeRuleSet,
    makeOtpRule,
    makeMetric,
    makeReport,
    makeReportGlobalFilters,
    normalizeReportConfigurationClient,
    findExistingPlanForClient,
    buildPlanFromClient,
    mergeClientLookupsIntoData,
    reportFolderUiId,
    reportUiId,
    reportFromDto,
    reportFolderFromDto,
    applyReportPlanToPlan,
    attachModel,
    columnsForModel,
    timestampColumnsForModel,
    breakdownColumnsForModel,
    extraBreakdownColumnsForModel,
    isTimestampColumnForModel,
    breakdownColumnForModel,
    DATE_GRANULARITY_OPTIONS,
    dateGranularityExpr,
    granularityLabel,
    extraBreakdownAlias,
    normalizeColumnIdentity,
    columnIdentityValues,
    columnMatchesKey,
    columnsMatch,
    findColumnByIdentity,
    tripDataColumnForKey,
    allSelectableColumnsForModel,
    resolveCountDistinctColumn,
    countAllExpr,
    countMatchingExpr,
    detailColumnsForModel,
    findSelectedDetailColumn,
    allColumnsAcrossModels,
    reportCategoryColumns,
    reportAllColumns,
    reportTimeComparableColumns,
    comparableColumnsForColumn,
    differenceColumnsForColumn,
    COLUMN_COMPARISON_OPERATORS,
    MINUTES_BETWEEN_OPERATORS,
    columnLabel,
    sqlList,
    sqlLiteral,
    nullSafeNotInRaw,
    idSqlList,
    inClause,
    notInClause,
    sqlLikeLiteral,
    sqlAlias,
    safeSqlAlias,
    indentSql,
    periodSqlClause,
    periodPlainEnglish,
    targetFields,
    reportColumnDisplayLabel,
    ruleResultValue,
    activeTripFilterCount,
    planPreviewText,
    modelColumnByKey,
    reportGlobalFilters,
    reportExclusionClausesForModel,
    tripDataFieldMatchExpr,
    tripDataGroupExpr,
    tripDataClausesForModel,
    periodClauseForModel,
    metricBreakdownExpr,
    extraBreakdownExprs,
    qualifySqlColumn,
    otpRuleColSql,
    buildLateConditionSql,
    ruleOpDef,
    findReportColumn,
    targetFieldDef,
    ruleConditionSql,
    ruleNodesExpression,
    ruleConditionExpression,
    ruleConditionOutline,
    ruleNodesOutline,
    ruleLogicOutline,
    ruleLogicComment,
    sqlCommentText,
    buildCatRulesColumns,
    buildRuleFilterClauses,
    isCategorizationRuleReady,
    ruleResultLabel,
    ruleValueColumn,
    ruleHasResult,
    ruleValueSourceIssue,
    ruleValueSourceColumns,
    categorizationRuleIssues,
    ruleSetIssues,
    isRuleSetReady,
    buildBaseWhereClauses,
    buildMetricFilterClauses,
    simulateConditionValue,
    simulateRuleNodes,
    simulateRuleMatches,
    simulateRuleSet,
    buildWhereClauses,
    isMetricReady,
    buildSqlForSection,
    modelKeyForRuleSet,
    buildCategorizationRuleSetSql,
    buildCategorizationSqlPreview,
    buildCallCenterSql,
    cteNameForModel,
    reportModelKeysForSql,
    ruleSetComputedColumnsForModel,
    combinedCategorizationColumnsForModel,
    ruleMetricColumn,
    categorizationOverrideForMetric,
    metricBreakdownSql,
    categorizationFilterClausesForMetric,
    matchingComputedColumn,
    buildMetricSource,
    sourceSqlForColumn,
    detailSelectSqlForColumn,
    buildReportCtes,
    metricResultSelect,
    buildReportSqlPreview,
    buildSqlPreview,
    buildExclusionSqlPreview,
    buildPlainEnglish,
    buildRuleBook,
    buildRuleBookText,
    findPlan,
    findFolder,
    findReport,
    sanitizeExcelSheetName,
    defaultExcelSheetName,
    normalizeExcelSheetName,
    excelSheetKey,
    validateExcelSheetName,
    metricSheetName,
    excelSheetsInUse,
    metricPositionWithinSheet,
    storedExcelSheetName,
    setMetricExcelSheet,
    moveExcelSheet,
    renameExcelSheet,
    reorderExcelSheets,
    reorderExcelMetrics,
    excelSectionAliases,
    makeDefaultExcelLayout,
    makeDefaultExcelDetailColumnOptions,
    reconcileExcelLayoutColumns,
    moveExcelDetailColumn,
    excelLayoutValidationMessages,
    excelLayoutColumnHeaders,
    buildExcelLayoutPreview,
    PERIOD_DATE_LABEL,
    isPeriodDateExtra,
    hasPeriodDate,
    makePeriodDateCase,
    periodDateGranularities,
    setPeriodDateGranularity,
    removePeriodDate,
    orphanPeriodDateExtras,
    periodDateColumns,
    periodDateColumn,
    enablePeriodDate,
    periodDateExpr,
    periodDateIssues,
    periodDateNarrative,
    extraBreakdownLabel,
    DETAIL_RULE_SET_ALIAS_PREFIX,
    detailRuleSetAlias,
    isDetailRuleSetAlias,
    selectedDetailRuleSetIds,
    usesDetailRuleSetList,
    withDetailRuleSetIds,
    withDetailRuleSetAlias,
    detailRuleSetAliasText,
    detailRuleSetDisplayName,
    DETAIL_RULE_SET_ALIAS_MAX_LENGTH,
    detailRuleSetOutputs,
    CALC_OPERATORS,
    MEASURE_AGGREGATES,
    MAX_CALC_TERMS,
    MAX_CALC_ROUND_DIGITS,
    CALC_FIELD_NAME_MAX_LENGTH,
    DETAIL_CALC_ALIAS_PREFIX,
    calculatedFields,
    isTextCalculatedField,
    numberCalculatedFieldsForModel,
    makeTextPart,
    makeTextStep,
    withCalculatedFieldResultType,
    calcTextColumns,
    calcTextOnlyColumns,
    textStepDef,
    TEXT_STEPS,
    TEXT_DATE_STYLES,
    MAX_TEXT_PARTS,
    MAX_TEXT_STEPS,
    MAX_TEXT_SEPARATOR_LENGTH,
    MAX_CALC_TEXT_LENGTH,
    calculatedFieldsForModel,
    findCalculatedField,
    detailCalcAlias,
    isDetailCalcAlias,
    detailCalculatedFieldIds,
    measureLabel,
    usesMeasureField,
    parseCalcTerms,
    isValidCalcNumber,
    makeCalculatedField,
    makeCalcTerm,
    calcNumberColumns,
    calcDateColumns,
    calculatedFieldSql,
    calculatedFieldEnglish,
    calculatedFieldIssues,
    isCalculatedFieldReady,
    simulateCalculatedField,
    calculatedFieldInputColumns,
    calcDifferenceUnits,
    detailCalculatedColumns,
    measureIssue,
    metricsUsingCalculatedField,
    withoutCalculatedField,
    setActiveReport,
    DETAIL_AGGREGATES,
    allowedDetailAggregates,
    defaultFormatForAggregate,
    detailAggregateDef,
    detailAggregateHeader,
    detailAggregateOf,
    usesDetailAggregates,
    detailOutputValueType,
    detailAggregateIssues,
    columnPickerLabel,
    calcColumnKey,
    isCalculatedColumn,
    isCalculatedColumnKey,
    isDatePartCalculatedField,
    calculatedFieldValueType,
    datePartColumns,
    DATE_PARTS,
    datePartDef,
    datePartFitsColumn,
    datePartsForColumn,
    isTimeOfDayColumn,
    calculatedColumnUses,
    ruleSetsUsingCalculatedField,
    calculatedColumnReferenceIssue,
    DETAIL_CONSTANT_TYPES,
    DETAIL_CONST_ALIAS_PREFIX,
    MAX_DETAIL_CONSTANT_COLUMNS,
    DETAIL_CONSTANT_NAME_MAX_LENGTH,
    detailConstAlias,
    isDetailConstAlias,
    detailConstantColumns,
    detailConstantIssue,
    detailConstantIssues,
    detailConstantSql,
    detailConstantText,
    COMBINED_MIN_RULE_SETS,
    COMBINED_ROW_LABEL_MAX_LENGTH,
    usesCombinedRuleSets,
    combinedRuleSetIds,
    combinedRows,
    activeCombinedRows,
    combinedRowLabel,
    generatedCombinedRowLabel,
    ruleSetCategories,
    ruleSetProducesCategory,
    combinedRuleSetUnavailableReason,
    combinedRuleSetSummary,
    combinedRuleSetOtherModelLabel,
    combinedOtherModelLabels,
    combinedRuleSetScope,
    combinedShareExplanation,
    makeCombinedRow,
    seedCombinedRows,
    countAndShareRows,
    duplicateCombinedRow,
    addCombinedRuleSet,
    removeCombinedRuleSet,
    switchBreakdownSource,
    switchDisplayAs,
    combinedRuleSetIssues,
    combinedRowCountColumns,
    withCombinedRowChange,
    withCombinedRowLabel,
    moveInList,
    stripSqlLineComments,
};
export type { PeriodDateIssue, DetailRuleSetOutput, DetailCalculatedColumn, CombinedIssue, RuleSetCategories, CalculatedColumnUse, DatePartDef, DatePartGroup, DetailAggregateIssue, DetailOutputValueType };
